import type { PayoutRescueTranslations } from "../interfaces/payoutRescue";

export const payoutRescueTranslations: PayoutRescueTranslations = {
  // Page
  page_title: "Rescate de dispersiones",
  page_subtitle: "Dispersiones cuyo envío automático falló: reintenta el envío o devuelve los fondos",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar la cola",
  error_load: "No pudimos cargar la cola de rescate.",
  error_retry: "Reintentar",

  // KPI strip
  kpi_pending_label: "Por rescatar",
  kpi_pending_caption: "Requiere acción",
  kpi_processing_label: "En proceso",
  kpi_processing_caption: "En el banco",
  kpi_paid_today_label: "Pagadas hoy",
  kpi_paid_today_caption: "Liquidadas",
  kpi_retained_label: "Monto retenido",

  // Tabs
  tab_pending: "Por rescatar",
  tab_processing: "En proceso",
  tab_history: "Historial",

  // Filters
  filter_search_placeholder: "Buscar por ID, organización o concepto",
  filter_org_label: "Organización",
  filter_all_orgs: "Todas las organizaciones",
  filter_corridor_label: "Corredor",
  filter_all_corridors: "Todos los corredores",
  filter_status_label: "Estado",
  filter_all_statuses: "Todos los estados",
  filter_clear: "Limpiar filtros",
  export_button: "Exportar",

  // Status labels
  status_created: "Por rescatar",
  status_processing: "Procesando",
  status_paid: "Pagada",
  status_failed: "Fallida",
  status_cancelled: "Cancelada",
  status_reversed: "Revertida",
  status_long_created: "Requiere rescate",
  status_long_processing: "Procesando en el banco",
  status_long_paid: "Pagada",
  status_long_failed: "Rechazada por el banco",
  status_long_cancelled: "Cancelada",
  status_long_reversed: "Revertida",

  // Table
  table_th_age: "Antigüedad",
  table_th_org: "Organización",
  table_th_corridor: "Corredor",
  table_th_beneficiary: "Beneficiario",
  table_th_concept: "Concepto",
  table_th_net: "Neto",
  table_th_status: "Estado",
  action_review: "Revisar",
  action_view: "Ver",
  empty_pending_title: "Todo al día",
  empty_pending_description: "Ninguna dispersión requiere rescate en este momento.",
  empty_processing_title: "Nada en proceso",
  empty_processing_description: "No hay dispersiones esperando confirmación del banco.",
  empty_history_title: "Sin historial",
  empty_history_description: "Aún no hay dispersiones finalizadas.",
  empty_filtered_description: "No hay dispersiones para los filtros seleccionados.",
  queue_truncated: "Mostrando las primeras {{shown}} de {{total}} — usa los filtros para acotar la lista.",
  pagination_summary: "Mostrando {{from}}–{{to}} de {{total}}",
  footer_order_pending: "Orden: más antiguas primero",

  // Drawer
  drawer_title: "Dispersión {{id}}",
  drawer_rescue_alert:
    "El envío automático no se completó. Reintenta el envío una vez corregida la configuración, o cancela para devolver los fondos.",
  drawer_org: "Organización",
  drawer_corridor: "Corredor",
  drawer_beneficiary: "Beneficiario",
  drawer_destination_unavailable: "Datos del destino no disponibles en esta vista",
  drawer_concept: "Concepto",
  drawer_reference: "Referencia",
  drawer_created: "Creada",
  drawer_failure_reason: "Motivo",
  copy_aria: "Copiar",
  copy_success: "Copiado al portapapeles",
  destination_label_clabe: "CLABE",
  destination_label_pix: "Llave PIX ({{type}})",
  destination_label_cbu_cvu: "Cuenta {{type}}",

  // Breakdown
  breakdown_title: "Desglose",
  breakdown_gross: "Bruto (debitado al cliente)",
  breakdown_fees: "Comisiones",
  breakdown_fee_coloca: "Comisión Coloca",
  breakdown_fee_network: "Costo de red (incluido)",
  breakdown_tax_absorbed: "lo asume Coloca",
  breakdown_economic_model: "Modelo económico",
  breakdown_net: "Neto (recibe el beneficiario)",

  // Timeline
  timeline_title: "Línea de tiempo · auditoría",
  timeline_source_staff: "Equipo Coloca",
  timeline_source_network: "Confirmación de la red bancaria",
  timeline_source_system: "Sistema",
  timeline_by: "por {{actor}}",
  timeline_error: "No se pudo cargar la línea de tiempo.",

  // Drawer actions
  actions_cancel: "Cancelar y devolver fondos",
  actions_retry: "Reintentar envío",
  processing_note: "En el banco — la confirmación llega en minutos. Sin acciones disponibles.",
  reconcile_soon: "Reconciliar (próximamente)",
  terminal_note: "Operación finalizada — solo lectura.",

  // Retry modal
  retry_title: "Reintentar envío de dispersión",
  retry_warning: "Esta acción envía dinero real y es irreversible. Revisa los datos antes de confirmar.",
  retry_summary_beneficiary: "Beneficiario",
  retry_summary_corridor: "Corredor",
  retry_summary_org: "Organización",
  retry_sends_label: "Se envía al beneficiario",
  retry_debits_caption: "Se debitan {{gross}} del cliente (incluye comisiones)",
  retry_confirm_check: "Confirmo que el beneficiario, el destino y el monto son correctos.",
  retry_confirm_check_no_destination: "Confirmo que la organización, el corredor y el monto son correctos.",
  retry_cancel: "Cancelar",
  retry_arming: "Revisa el resumen…",
  retry_confirm: "Confirmar envío",
  retry_sending_title: "Enviando al banco…",
  retry_sending_caption: "Contactando la red {{corridor}}. No cierres esta ventana.",
  retry_done_processing_title: "Enviada al banco",
  retry_done_processing_msg: "Está en camino. La confirmación del banco llega en minutos.",
  retry_done_paid_title: "¡Pagada!",
  retry_done_paid_msg:
    "El banco liquidó la transferencia de inmediato. El beneficiario ya recibió los fondos.",
  retry_done_failed_title: "Rechazada por el banco",
  retry_done_failed_msg:
    "La red rechazó la operación. Los fondos volvieron al saldo disponible del cliente. No puede reenviarse.",
  retry_done_stuck_title: "No se pudo enviar",
  retry_done_stuck_msg:
    "El corredor no está configurado. Contacta a plataforma y reintenta cuando esté resuelto. La dispersión sigue pendiente de rescate.",
  retry_done_race_title: "Ya fue procesada",
  retry_done_race_msg: "Otro operador procesó esta dispersión. Se actualizó con su estado actual.",
  retry_done_button: "Listo",

  // Cancel modal
  cancel_title: "Cancelar dispersión",
  cancel_body:
    "Los fondos reservados ({{gross}}) vuelven al saldo disponible de {{org}}. La dispersión quedará como Cancelada.",
  cancel_reason_label: "Motivo (opcional)",
  cancel_reason_placeholder: "Ej. datos del beneficiario inválidos",
  cancel_back: "Volver",
  cancel_confirm: "Cancelar y devolver fondos",
  cancel_error: "No se pudo cancelar la dispersión.",

  // Toasts
  toast_retry_processing: "Enviada — esperando confirmación del banco",
  toast_retry_paid: "Dispersión pagada",
  toast_retry_failed: "Rechazada por el banco — fondos devueltos",
  toast_retry_stuck: "No se pudo enviar — corredor no configurado",
  toast_race: "Ya fue procesada por otro operador",
  toast_cancelled: "Fondos devueltos al cliente",
};
